import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';

import {
  CancelAppointmentDocument,
  CancelAppointmentReason,
  GetUncompletedAppointmentsNotificationsCountDocument,
} from '~/graphql/generated/graphql';
import { profileDrawerState } from '~/state/partials/patient_profile_drawer/atoms';

export const useCancelAppointment = (appointmentId: string) => {
  const [isCanceling, setIsCanceling] = useState(false);
  const setProfileDrawerState = useSetAtom(profileDrawerState);

  const [cancel] = useMutation(CancelAppointmentDocument, {
    refetchQueries: [{ query: GetUncompletedAppointmentsNotificationsCountDocument }],
  });

  const handleCancel = useCallback(
    async (reason: CancelAppointmentReason) => {
      setIsCanceling(true);
      setProfileDrawerState((_state) => ({ ..._state, error: null }));

      try {
        await cancel({
          variables: {
            input: {
              appointmentId,
              reason,
            },
          },
        });
      } catch (_error) {
        setProfileDrawerState((_state) => ({
          ..._state,
          error: _error?.message || 'エラーが発生しました',
        }));
      } finally {
        setIsCanceling(false);
      }
    },
    [setProfileDrawerState, appointmentId, cancel],
  );

  return {
    canceling: isCanceling,
    handleCancel,
  };
};
